import { FORM_NAME } from '../data/constants';
import { DisbursementFormTransformer, FormBuilder, FormShape } from '../types';

const getDisbursementForm = (
	props: DisbursementFormTransformer,
	name = FORM_NAME.disbursement,
) => {
	const { fields: disbursementFields, fieldValues, mediaByLocator } = props;

	const fields = [];

	if (disbursementFields) {
		fields.push(...disbursementFields);
	}

	return {
		[name]: {
			fields,
			mediaByLocator,
			values: fieldValues,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export interface DisbursementFormValues {
	disbursement: {
		amountCurrency: string;
		amount: string;
		policyholderLocator?: string;
		policyLocator?: string;
		[configuredFields: string]: string | boolean | number | string[] | number[];
	};
}

export interface DisbursementDirtyFields {
	disbursement?: {
		[x: string]: boolean | boolean[];
		currency?: boolean;
		amount?: boolean;
		policyholderLocator?: boolean;
		policyLocator?: boolean;
	};
}

export default getDisbursementForm;
